// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "软件需求管理",
        "tec": "吴赜书",
        "week": "1-12周",
        "add": "实训楼F座402信息"
      },
      {
        "sub": "劳动与创造",
        "tec": "侯荣旭",
        "week": "17周",
        "add": "教学楼C座303教务"
      }
    ],
    [
      {
        "sub": "面向对象分析与设计",
        "tec": "于舜",
        "week": "1-16周",
        "add": "教学楼B座324能动"
      },
      {
        "sub": "劳动与创造",
        "tec": "侯荣旭",
        "week": "17周",
        "add": "教学楼C座303教务"
      }
    ],
    0,
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "国家安全教育",
        "tec": "李芗霓",
        "week": "9-12周",
        "add": "图书馆1楼党史+网络数字教育基地"
      }
    ],
    0
  ],
  "2": [
    {
      "sub": "创新思维训练",
      "tec": "田丰",
      "week": "1-16周",
      "add": "教学楼D座422信息AISEC"
    },
    {
      "sub": "Web程序设计",
      "tec": "关颖",
      "week": "1-16单周",
      "add": "教学楼B座420能动"
    },
    {
      "sub": "计算机网络",
      "tec": "宋敏",
      "week": "1-16周",
      "add": "实训楼F座402信息"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "软件需求管理",
      "tec": "吴赜书",
      "week": "1-12周",
      "add": "教学楼C座302教务"
    },
    {
      "sub": "操作系统原理",
      "tec": "曲乐声",
      "week": "1-16周",
      "add": "教学楼B座218自控"
    },
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "国家安全教育",
        "tec": "李芗霓",
        "week": "9-12周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "劳动与创造",
        "tec": "侯荣旭",
        "week": "17周",
        "add": "教学楼C座302教务"
      }
    ],
    [
      {
        "sub": "Web程序设计",
        "tec": "关颖",
        "week": "1-16周",
        "add": "教学楼B座221自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "侯荣旭",
        "week": "17周",
        "add": "教学楼C座302教务"
      }
    ],
    [
      {
        "sub": "计算机网络",
        "tec": "宋敏",
        "week": "1-16双周",
        "add": "实训楼F座302信息"
      },
      {
        "sub": "面向对象分析与设计",
        "tec": "于舜",
        "week": "1-16单周",
        "add": "实训楼F座302信息"
      }
    ],
    0,
    0
  ],
  "5": [
    0,
    {
      "sub": "操作系统原理",
      "tec": "曲乐声",
      "week": "1-16单周",
      "add": "实训楼F座202自控"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
